export let ProgressState = {
  ROOT_LOADED: 0,
  LOADING: 1,
  RENDERING: 2
};